import styled, { css } from "styled-components";

/**
 * This file only configures styles for the TextField of the MUI X DatePicker component
 * @see src/theme/globals/muiDatePickerCssOverwrite.ts for overwriting default MUI X DatePicker component styles (Calendar pop up only)
 */
const CalanderIconWrapper = styled.div<{ disabled?: boolean; error?: boolean }>`
    display: flex;
    position: relative;

    .MuiInputAdornment-root {
        position: absolute;
        top: 14px;
        right: 13px;

        button {
            color: ${(props) => props.theme.colors["white.50"]};
            
            ${({ disabled }) => disabled && css`
                color: ${(props) => props.theme.colors["white.25"]};
            `};

            ${({ error }) => error && css`
                color: ${(props) => props.theme.colors.error.strong};
            `};
        }
    }
`;

export { CalanderIconWrapper };
